
import { Thumbs, Navigation } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";
import UiSpinner from "@/components/UI/UiSpinner.vue";
import UiLazyVideo from "@/components/UI/UiLazyVideo.vue";
import ExpandSvg from "~/components/svg/ExpandSvg.vue";
SwiperCore.use([Thumbs, Navigation]);

export default {
  components: {
    ExpandSvg,
    // VueSlickCarousel,
    Swiper,
    SwiperSlide,
    UiSpinner,
    UiLazyVideo,
  },
  props: {
    product: {
      type: Object,
      default() {
        return {};
      },
    },
    configurationInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      thumbnailConfig: {
        navigation: {
          prevEl: ".general-sticky-slider .thumbs-btn-prev",
          nextEl: ".general-sticky-slider .thumbs-btn-next",
        },
        breakpoints: {
          320: {
            // direction: "horizontal",
            spaceBetween: 10,
          },
          992: {
            direction: "vertical",
            spaceBetween: 20,
          },
        },
      },
      thumbsSwiper: null,
      mainSwiper: null,
      isHorizontalSwiper: false,
      thumbsSwiperDesktopSize: 0,
      imageLoading: false,
      isHorizontalSwiperLoaded: false,
      activeIndex: 0,
      viewImageDialog: false,
    };
  },

  computed: {
    productMedia() {
      const result = [];
      const mainImages = this.configurationInfo?.medias?.filter((item) =>
        item.position.includes("PDP")
      );
      if (mainImages?.length) {
        const temp = mainImages.map((el) => ({
          showFileViewer: true,
          ...el,
          ...el.file,
        }));
        result.push(...temp);
      }
      this.product?.marketing_images?.forEach((item) => {
        item.listType = "media";
        item.showFileViewer = true;
        result.push(item);
      });
      if (!result?.length && this.configurationInfo) {
        const defaultImage = {
          showFileViewer: false,
          media_type: "image/jpeg",
          url: "/images/no-image.webp",
          listType: "render",
          noImage: true,
        };
        result.push(defaultImage);
      }
      return result;
    },
    fileToPreview() {
      return this.productMedia[this.activeIndex];
    },
    slidesPerView() {
      if (process.server) {
        return 1;
      } else {
        return "auto";
      }
    },
  },
  watch: {
    async configurationInfo() {
      this.imageLoading = true;
      this.mainSwiper.slideTo(0);

      const filteredImage = Promise.all(
        this.productMedia.map((img) => {
          const url = this.loadImage(img.file?.url || img.url);
          return url;
        })
      );

      const promises = await filteredImage;
      this.imageLoading = false;
    },
  },
  mounted() {
    this.$root.$on("stickyVerticalSlideChange", this.setVerticalSlide);
    this.$root.$on("stickyHorizontalSlideChange", this.setHorizontalSlide);
  },
  methods: {
    setVerticalSlide(index) {
      this.thumbsSwiper.slideTo(index);
    },
    setHorizontalSlide(index) {
      this.mainSwiper.slideTo(index);
    },
    verticalSlideChange(e) {
      this.$root.$emit("generalVerticalSlideChange", e?.activeIndex || 0);
    },
    horizontalSlideChange(e) {
      this.activeIndex = e?.activeIndex || 0;
      this.$root.$emit("generalHorizontalSlideChange", this.activeIndex);
    },
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
    initMainSwiper(swiper) {
      this.mainSwiper = swiper;
      this.thumbsSwiperDesktopSize = swiper.size;
      this.isHorizontalSwiper = swiper.isHorizontal();
      setTimeout(() => {
        this.isHorizontalSwiperLoaded = true;
      }, 700);
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          resolve(null);
        };
        img.src = url;
      });
    },
    isVideo(item) {
      return item?.media_type?.includes("video");
    },
    openFilePreview() {
      this.$emit("openPreview", this.fileToPreview);
    },
  },
};
